import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import TableRow from "@material-ui/core/TableRow";
import withStyles from "components/with-styles";
import styles from "./styles/custom-table-row.css.js";


const CustomTableRow = ({ href, history, children, classes, className, disabled, onClick }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (href && !disabled) {
    history.push(href);
    } else if (!disabled && !href){
      onClick();
    } else{
      null;
    } 
  }
  return (
    <TableRow
      hover
      className={cn(classes.tableRow, className, { [classes.tableRow__disabled]: disabled })}
      onClick={(e) => handleClick(e)}
    >
      {children}
    </TableRow>
  );
};

CustomTableRow.propTypes = {
  /**
   * Url del enlace de la fila
   **/
  href: PropTypes.string,
  /**
   * Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   * Indica si está desactivada la fila
   **/
  disabled: PropTypes.bool,
  /**
   * Callback para cuando se realiza clic en la fila
   **/
  onClick: PropTypes.func,
};

export default withStyles(styles)(withRouter(CustomTableRow));
